import React, { useEffect, useState } from 'react'
import './style.scss';
import { setButtonClick, setErrorButton, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setIsShowButtonNot } from '../../store/buttonNotSlice';
import CustomTitle from '../../components/UI/title/CustomTitle';
import CurrentContent from './CurrentContent';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';

export default function Current({ productivity }) {

    const initialCheckboxState = [[
        {
            id: 0,
            checked: false,
            text: "0–10",
        },
        {
            id: 1,
            checked: false,
            text: "10–30",
        },
        {
            id: 2,
            checked: false,
            text: "30–70",
        },
        {
            id: 3,
            checked: false,
            text: "70–150",
        },
        {
            id: 4,
            checked: false,
            text: "150+",
        }
    ], [
        {
            id: 0,
            checked: false,
            text: "Not sure",
        },

        {
            id: 1,
            checked: false,
            text: "$0-10",
        },
        {
            id: 2,
            checked: false,
            text: "$10-20",
        },
        {
            id: 3,
            checked: false,
            text: "$20-50",
        },
        {
            id: 4,
            checked: false,
            text: "$50-100",
        },
        {
            id: 5,
            checked: false,
            text: "$100+",
        }
    ], [
        {
            id: 0,
            checked: false,
            text: "Not sure",
        },
        {
            id: 1,
            checked: false,
            text: "0-1",
        },
        {
            id: 2,
            checked: false,
            text: "1–2",
        },
        {
            id: 3,
            checked: false,
            text: "2–3",
        },
        {
            id: 4,
            checked: false,
            text: "4–5",
        },
        {
            id: 5,
            checked: false,
            text: "5+",
        }
    ], [
        {
            id: 0,
            checked: false,
            text: "0-1%",
        },
        {
            id: 1,
            checked: false,
            text: "1-3%",
        },
        {
            id: 2,
            checked: false,
            text: "3-5%",
        },
        {
            id: 3,
            checked: false,
            text: "5-10%",
        },
        {
            id: 4,
            checked: false,
            text: "10-15%",
        },
        {
            id: 5,
            checked: false,
            text: "15% or more",
        }
    ]];

    const initialCheckboxStateProductivity = [[
        {
            id: 0,
            checked: false,
            text: "None",
        },
        {
            id: 1,
            checked: false,
            text: "Up to 3",
        },
        {
            id: 2,
            checked: false,
            text: "Up to 10",
        },
        {
            id: 3,
            checked: false,
            text: "Up to 30",
        },
        {
            id: 4,
            checked: false,
            text: "Up to 100",
        },
        {
            id: 5,
            checked: false,
            text: "More than 100",
        }
    ],
    [
        {
            id: 0,
            checked: false,
            text: "Up to $20",
        },
        {
            id: 1,
            checked: false,
            text: "Up to $50",
        },
        {
            id: 2,
            checked: false,
            text: "Up to $100",
        },
        {
            id: 3,
            checked: false,
            text: "Up to $200",
        },
        {
            id: 4,
            checked: false,
            text: "Up to $500",
        },
        {
            id: 5,
            checked: false,
            text: "$500 and more",
        }
    ], [
        {
            id: 0,
            checked: false,
            text: "None",
        },

        {
            id: 1,
            checked: false,
            text: "Up to 3",
        },
        {
            id: 2,
            checked: false,
            text: "Up to 10",
        },
        {
            id: 3,
            checked: false,
            text: "Up to 30",
        },
        {
            id: 4,
            checked: false,
            text: "Up to 100",
        },
        {
            id: 5,
            checked: false,
            text: "More than 100",
        }
    ], [
        {
            id: 0,
            checked: false,
            text: "Up to $10",
        },
        {
            id: 1,
            checked: false,
            text: "Up to $20",
        },
        {
            id: 2,
            checked: false,
            text: "Up to $50",
        },
        {
            id: 3,
            checked: false,
            text: "Up to $100",
        },
        {
            id: 4,
            checked: false,
            text: "Up to $300",
        },
        {
            id: 5,
            checked: false,
            text: "More than $300",
        }
    ], [
        {
            id: 0,
            checked: false,
            text: "0",
        },
        {
            id: 1,
            checked: false,
            text: "1",
        },
        {
            id: 2,
            checked: false,
            text: "3",
        },
        {
            id: 3,
            checked: false,
            text: "10",
        },
        {
            id: 4,
            checked: false,
            text: "50",
        },
        {
            id: 5,
            checked: false,
            text: "100+",
        }
    ],
    [
        {
            id: 0,
            checked: false,
            text: "Up to $100",
        },
        {
            id: 1,
            checked: false,
            text: "Up to $200",
        },
        {
            id: 2,
            checked: false,
            text: "Up to $500",
        },
        {
            id: 3,
            checked: false,
            text: "Up to $1,000",
        },
        {
            id: 4,
            checked: false,
            text: "Up to $2,000",
        },
        {
            id: 5,
            checked: false,
            text: "More than $2,000",
        }
    ]];

    const title = [
        'How many purchases do you get each month?',
        'What’s your average CPA?',
        'What’s your current ROAS?',
        'What’s your current CTR?'
    ]

    const titleProductivity = [
        'How many video ads do you create per month?',
        'How much does it cost you to create a video ad?',
        'How many static ads do you create per month?',
        'How much do you spend per static ad creation?',
        'How many campaigns do you launch per month?',
        'What’s your monthly spend on ad campaign handling?'
    ]
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);


    const [disabled, setDisabled] = useState(true);
    const [checkboxes, setCheckboxes] = useState(productivity ? initialCheckboxStateProductivity[queryParams.get('productivity-goals-id') ?? 0] : initialCheckboxState[queryParams.get('goals') ?? 0]);
    const [error, setError] = useState(false);
    const [value, setValue] = useState('');
    const [valueId, setValueId] = useState('');

    const dispatch = useDispatch();
    const history = useHistory();
    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const { trackP1Event } = useMixpanel();
    useEffect(() => {
        if (buttonClicked) {
            if (disabled) {
                setError(true);
                dispatch(setErrorButton(true))
                dispatch(setButtonClick(false));
                setTimeout(() => {
                    setError(false);
                    dispatch(setErrorButton(false))
                }, 2000);
                return;
            }
            dispatch(setButtonClick(false));
            queryParams.set('current', value);
            queryParams.set('current-id', valueId);
            trackP1Event('onboarding_ad_current', {
                current_productivity: value,
                goals: queryParams.get('goals-text')
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`,
            });
        }
    }, [buttonClicked, dispatch, disabled]);


    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('Continue'));
        dispatch(setIconButton(''));

        dispatch(setIsShowButtonNot(false));
    }, []);


    return (
        <div className=" page">
            <PageContent>
                <div className="page-content" style={{ paddingRight: '1rem' }}>
                    <CustomTitle
                        style={{ marginBottom: '24rem' }}
                        title={productivity ? titleProductivity[queryParams.get('productivity-goals-id') ? queryParams.get('productivity-goals-id') : 0] : title[queryParams.get('goals') ? queryParams.get('goals') : 0]}
                    />

                    <CurrentContent setValueId={setValueId} setValue={setValue} checkboxes={checkboxes} setCheckboxes={setCheckboxes} error={error} setDisabled={setDisabled} setError={setError} />

                </div>
            </PageContent>

        </div>
    )
}
